<template>
  <div class="content">
    <section class="page-intro bt-none">
      <p class="tag-list">
        <span class="f-ticker">1987</span><span class="accent-1"> – </span
        ><span class="f-ticker">present</span>
      </p>
      <p class="tag-list">
        <span class="tag icon-text">Streaming live from Austin, TX</span>
      </p>
    </section>
    <section id="info">
      <p class="tag-list credit">
        <span>Photo: </span>
        <a href="https://www.gabadilla.com/">Gabe Abadilla</a>
      </p>
    </section>

    <section>
      <div class="row">
        <div class="column column-50">
          <h2 class="mt-0">Information</h2>
          <p class="indent">I'm Matt — a designer based in Austin, TX.</p>
          <p>
            Over 17 years, I've led design for a wide range of projects—from the
            future of car buying experiences for Volkswagen, women's health for
            Modern Fertility, AI-powered search for Forethought, and data
            visualization for the Department of Defense for COVID-19 related
            supply chain management and risk mitigation.
          </p>

          <p>
            Previously, I lived in in Los Angeles, where I worked with HBO,
            Lionsgate, and others on various spinoff projects and microsites.
          </p>

          <p>
            Along the way, I’ve worked on projects across nearly every vertical.
            I've had the privilege of helping dozens of startups — at every
            stage — develop systems and guidelines that have helped them get off
            the ground, raise money, and improve their products post-series.
          </p>
        </div>
      </div>
    </section>

    <section class="services pb-0">
      <div class="row">
        <div class="column">
          <h2 class="mt-0 mb-1">Disciplines</h2>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <p class="service">Creative Direction</p>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <p class="service">Product Design</p>
        </div>
        <div class="column">
          <p class="service">Design Systems</p>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <p class="service">Branding &amp; Naming</p>
        </div>
        <div class="column">
          <p class="service">Motion & Interaction</p>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <p class="service">Rapid Prototyping</p>
        </div>
        <div class="column">
          <p class="service">UI Engineering</p>
        </div>
      </div>
    </section>
    <section class="testimonial">
      <div class="row">
        <div class="column column-offset-50 mobile-full">
          <blockquote>
            <p>
              "Matt is an extraordinarily talented interaction and visual
              designer. I have worked with Matt for many years and can say
              without hesitation that he is a remarkable designer. Matt is
              adaptable, hard-working, and detail-oriented. He can easily design
              products across industries and categories.
            </p>
            <p>
              In our work for the Department of Defense and government, he
              proved time and again that he cares deeply about the mission and
              creating a positive impact in the world with design and
              technology. Matt brings passion to the job, which you can see in
              his work.
            </p>
            <p>
              He takes feedback well, coming back with solutions that are even
              better than expected. I personally enjoy collaborating with Matt
              and recommend him to the highest degree."
            </p>
            <p class="highlight">
              <cite>— Shaun Modi, Managing Partner, TM</cite>
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped lang="scss">
.services {
  position: relative;
  padding-bottom: 0;
  .column {
    border-bottom: 1px solid var(--color-border-light);
  }
  .row:last-child > .column:last-child {
    border-bottom: none;
  }
  .service {
    font-family: "Geist";
    font-weight: 200;
    font-size: 2.5rem;
    margin: 0;
    padding: 1rem 0;
  }
}
@media (min-width: 40rem) {
  .services {
    .row:last-child > .column {
      border-bottom: none;
    }
  }
}
.testimonial {
  blockquote {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.profile-image {
  width: 50%;
  height: 100%;
  object-fit: cover;
  margin-top: 1rem;
  user-select: none;
  pointer-events: none;
}
#info {
  background-image: url("@/assets/images/profile.png");
  background-size: contain;
  background-position: bottom center;
  background-repeat: no-repeat;
  background-color: var(--color-page-initial);
  min-height: 50vh;
  position: relative;
  .credit {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    font-size: 1.25rem;
  }

  @media (max-width: 80rem) {
    min-height: 30vh;
  }
}
</style>
